import { useState } from 'react';

export default function useCheckBoxPixTransaction(data, setTotalSelected) {
  const [transactionSelected, setTransactionSelected] = useState([]);

  const verifyIfAllTransactionsAreSelected = () => {
    const currentPageIds =
      data
        ?.map((transaction) =>
          transaction?.STATUS === 'AGUARDANDO' && transaction.TIPO_TRANSACAO_PIX == 'PAGAMENTO' ? transaction.ID : null,
        )
        .filter((id) => id != null) || [];
    const allSelected = currentPageIds.length > 0 && currentPageIds.every((id) => transactionSelected.includes(id));

    return allSelected;
  };
  const handleChangeSelectAll = (event) => {
    const currentPageIds =
      data
        ?.map((transaction) =>
          transaction?.STATUS === 'AGUARDANDO' && transaction.TIPO_TRANSACAO_PIX == 'PAGAMENTO' ? transaction.ID : null,
        )
        .filter((id) => id != null) || [];

    const totalValueSelected = data?.reduce(
      (total, transaction) => (transaction?.STATUS === 'AGUARDANDO' ? total + parseFloat(transaction.VALOR) : total),
      0,
    );

    // Se todos da página estão marcados, desmarque apenas os da página atual
    const allSelected = currentPageIds.length > 0 && currentPageIds.every((id) => transactionSelected.includes(id));
    if (allSelected) {
      setTransactionSelected((prev) => prev.filter((id) => !currentPageIds.includes(id)));
      setTotalSelected((prev) => ({
        ...prev,
        totalTransactions: 0,
        totalValue: 0,
      }));
      return;
    }

    if (event.target.checked) {
      setTransactionSelected((prev) => {
        // Mantém as seleções anteriores e adiciona as novas da página atual
        const uniqueIds = new Set([...prev]);
        currentPageIds.forEach((id) => uniqueIds.add(id));
        return Array.from(uniqueIds);
      });

      setTotalSelected((prev) => ({
        ...prev,
        totalTransactions: currentPageIds.length,
        totalValue: totalValueSelected,
      }));
    } else {
      // Remove apenas as seleções da página atual
      setTransactionSelected((prev) => prev.filter((id) => !currentPageIds.includes(id)));

      setTotalSelected((prev) => ({
        ...prev,
        totalTransactions: 0,
        totalValue: 0,
      }));
    }
  };

  return {
    transactionSelected,
    setTransactionSelected,
    handleChangeSelectAll,
    verifyIfAllTransactionsAreSelected,
  };
}
